import { render, staticRenderFns } from "./MobileWarningModal.vue?vue&type=template&id=00a166b4&scoped=true"
import script from "./MobileWarningModal.vue?vue&type=script&lang=js"
export * from "./MobileWarningModal.vue?vue&type=script&lang=js"
import style0 from "./MobileWarningModal.vue?vue&type=style&index=0&id=00a166b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a166b4",
  null
  
)

export default component.exports